<template>
    <div>
        <wrapper-edit
                :wrapper-width="wrapperWidth"
                @back="paasPageBack">
            <Tabs type="card" slot="form"
                  @on-click="justifyShow"
                  ref="tabWrap"
                  class="form-tabs">
                <TabPane label="商品信息">
                    <Form ref="paasForm"
                          :model="paasFormData"
                          :rules="paasFormRules"
                          :label-width="defaultLabelWidth"
                          class="product-edit-wrap">
                        <Row>
                            <FormItem label="分类：" prop="fkaStoreCategoryName" class="ivu-col-span-12" v-clickoutside="handlefkaStoreCategoryNameClose">
                                <Input v-model="paasFormData.fkaStoreCategoryName"
                                       @on-focus="changefkaStoreCategoryNameFlag"
                                       @on-clear="clearfkaStoreCategoryName" clearable  readonly="readonly"></Input>
                                <select-tree @selected-tree-value="updatefkaStoreCategoryNameTreeNode"
                                             @check-tree-value="updatefkaStoreCategoryNameTreeNode"
                                             multiple
                                             serviceUrl='/eb/store/category'
                                             ref="categoryTree"
                                             v-show="showfkaStoreCategoryNameTree"/>
                            </FormItem>
                            <FormItem label="产品名称：" prop="name" class="ivu-col-span-12" >
                                <Input v-model="paasFormData.name"
                                       clearable ></Input>

                            </FormItem>
                        </Row>

                        <Row>
                            <FormItem label="货号：" prop="productNo" class="ivu-col-span-12" >
                                <Input v-model="paasFormData.productNo"
                                       clearable ></Input>

                            </FormItem>
                            <FormItem label="产品关键字：" prop="keyword" class="ivu-col-span-12" >
                                <Input v-model="paasFormData.keyword"
                                       clearable ></Input>

                            </FormItem>
                        </Row>
                        <Row>
                            <FormItem label="产品简介：" prop="storeInfo" class="ivu-col-span-24" >
                                <Input v-model="paasFormData.storeInfo"
                                       type="textarea"  clearable ></Input>

                            </FormItem>
                        </Row>
                        <Row>
                            <FormItem label="品牌：" prop="brand" class="ivu-col-span-12" >
                                <Enum :enumJsonKey="'crmdict-brand'"
                                      v-model="paasFormData.brand" @on-change="changeBrand">
                                </Enum>
                            </FormItem>
                            <FormItem label="商品毛重：" prop="goodWight" class="ivu-col-span-12" >
                                <Input v-model="paasFormData.goodWight"
                                       clearable >
                                <span slot="append">公斤</span>
                                </Input>
                            </FormItem>
                        </Row>
                        <Row>
                            <FormItem label="产品视频:" prop="videoUrl" class="ivu-col-span-24" >
                                <multiUploader
                                        :fileList.sync="fileList"
                                        :businessId="paasFormData.id"
                                        :tempId="paasFormData.paasRepeatSubmitFlag"
                                        uploadTitle="上传视频"
                                        businessType="StoreProduct"
                                        :single="true"
                                        businessProperty="video"
                                        uploadType="video">

                                </multiUploader>
                            </FormItem>
                        </Row>
                        <Row>
                            <FormItem label="产品轮播图(640*640px):" prop="sliderImage" class="ivu-col-span-24" >
                                <div class="fc-upload-btn" ref="multiUploadBtn" @click="openUploadPanel('multiUploadModal','multiUploadBtn','multiFileModal')">
                                    <Icon type="md-camera" size="20"/>
                                </div>
                                <div class="file-upload-list multi-upload-list" v-if="sliderFiles.length > 0">
                                    <template v-for="(item,index) in sliderFiles">
                                        <Card class="multi-card-wrap"
                                              @mouseover.native="curFinishIndex=index"
                                              @mouseout.native="curFinishIndex=-1">
                                            <img :src="item.thumbnailUrl" >
                                            <div class="file-upload-list-cover" v-show="curFinishIndex === index">
                                                <Icon type="ios-eye-outline" @click.native="handleView(item.originalUrl)"></Icon>
                                                <Icon type="ios-trash-outline" @click.native="handleFinishRemove(item)"></Icon>
                                            </div>
                                        </Card>
                                    </template>
                                </div>
                            </FormItem>
                        </Row>
                        <Row>
                            <FormItem label="产品宣传图:" prop="posterImage" class="ivu-col-span-6" >
                                <div class="file-upload-list" v-if="paasFormData.posterImage">
                                    <template>
                                        <img :src="paasFormData.posterImage">
                                        <div class="file-upload-list-cover">
                                            <Icon type="ios-eye-outline" @click.native="handleView(imageFile.originalUrl)"></Icon>
                                            <Icon type="ios-trash-outline" @click.native="handleSingleRemove(imageFile.deleteUrl)"></Icon>
                                        </div>
                                    </template>
                                </div>
                                <div class="fc-upload-btn" ref="uploadBtn" @click="openUploadPanel('uploadModal','uploadBtn','fileModal')"
                                    v-if="!paasFormData.posterImage && paasFormData.posterImage === ''">
                                    <Icon type="md-camera" size="20"/>
                                </div>
                            </FormItem>
                        </Row>
                        <Row>
                            <FormItem label="售价：" prop="price" class="ivu-col-span-6" >
                                <InputNumber v-model="paasFormData.price" ></InputNumber>
                            </FormItem>
                            <FormItem label="赠送积分：" prop="giveIntegral" class="ivu-col-span-6" >
                                <InputNumber v-model="paasFormData.giveIntegral" ></InputNumber>
                            </FormItem>
                            <FormItem label="邮费：" prop="postage" class="ivu-col-span-6" >
                                <InputNumber v-model="paasFormData.postage" ></InputNumber>
                            </FormItem>
                            <FormItem label="排序：" prop="sort" class="ivu-col-span-6" >
                                <InputNumber v-model="paasFormData.sort" ></InputNumber>
                            </FormItem>
                        </Row>
                        <Row>
                            <FormItem label="产品状态：" prop="isShow" class="ivu-col-span-8" >
                                <Enum :enumJsonKey="'crmdict-isSale'"
                                      v-model="paasFormData.isShow"
                                      type="radio" ></Enum>
                            </FormItem>
                            <FormItem label="热卖单品：" prop="isHot" class="ivu-col-span-8" >
                                <Enum :enumJsonKey="'crmdict-isHot'"
                                      v-model="paasFormData.isHot"
                                      type="radio" ></Enum>
                            </FormItem>
                            <FormItem label="会员特惠：" prop="isBenefit" class="ivu-col-span-8" >
                                <Enum :enumJsonKey="'crmdict-isBenefit'"
                                      v-model="paasFormData.isBenefit"
                                      type="radio" ></Enum>
                            </FormItem>
                        </Row>
                        <Row>
                            <FormItem label="精品推荐：" prop="isBest" class="ivu-col-span-8" >
                                <Enum :enumJsonKey="'crmdict-isBest'"
                                      v-model="paasFormData.isBest"
                                      type="radio" ></Enum>
                            </FormItem>
                            <FormItem label="首发新品：" prop="isNew" class="ivu-col-span-8" >
                                <Enum :enumJsonKey="'crmdict-isNew'"
                                      v-model="paasFormData.isNew"
                                      type="radio" ></Enum>
                            </FormItem>
                            <FormItem label="是否包邮：" prop="isPostage" class="ivu-col-span-8" >
                                <Enum :enumJsonKey="'crmdict-isPostage'"
                                      v-model="paasFormData.isPostage"
                                      type="radio" ></Enum>
                            </FormItem>
                        </Row>
                        <div class="edit-oper-toolbar">
                            <Button type="primary" @click="paasFormSubmit()">保存</Button>
                            <Button @click="paasPageBack" style="margin-left: 8px">返回</Button>
                        </div>
                        <Modal title="图片预览" v-model="visible">
                            <img :src="viewPic" v-if="visible" style="width: 100%">
                        </Modal>
                    </Form>
                </TabPane>
                <TabPane label="销售属性" >
                    <div v-show="showAttr">
                        <Form v-model="saleForm">
                            <div class="field-wrap" v-for="(field,key) in saleMap" :key="key">
                                <p class="field-prop-title">
                                    <EnumShow
                                            :enum-group-code="'crmdict'"
                                            :enum-code="'saleAttr'"
                                            :value="key"></EnumShow>
                                    <Checkbox
                                            :indeterminate="saleCheck[key].indeterminate"
                                            :value="saleCheck[key].checkAll"
                                            @click.prevent.native="handleCheckAll(key)">全选</Checkbox>
                                </p>
                                <CheckboxGroup  v-model="saleForm[key]" class="checkbox-flex" @on-change="changeCheckedKey">
                                    <Checkbox :label="item.fieldDataPropMap.color.value"
                                              v-for="(item,index) in field" :key="index"
                                              span="4" v-if="key==='color'" @click.native="clickSingleCheckbox(item.fieldDataPropMap.color.value,key)">
                <span :style="{width:'10px',height:'10px',background:item.fieldDataPropMap.color.value,border:'1px solid transparent',borderRadius:'5px'}">&nbsp;&nbsp;&nbsp;
                </span>
                                        <span>{{item.fieldDataPropMap.name.value}}</span>
                                    </Checkbox>
                                    <Checkbox :label="item.fieldDataPropMap.name.value"
                                              v-for="(item,index) in field"
                                              :key="index" span="4"
                                              v-if="key!=='color'" @click.native="clickSingleCheckbox(item.fieldDataPropMap.name.value,key)">
                                        <span>{{item.fieldDataPropMap.name.value}}</span>
                                    </Checkbox>
                                </CheckboxGroup>
                                <br/>
                            </div>
                        </Form>
                    </div>
                    <div v-show="!showAttr">
                        请先填写商品信息
                    </div>
                    <table class="product-prop-table" cellspacing="0" cellpadding="0">
                        <thead>
                        <tr>
                            <th v-for="(field,key) in saleMap" :key="key">
                                <EnumShow
                                        :enum-group-code="'crmdict'"
                                        :enum-code="'saleAttr'"
                                        :value="key"></EnumShow>
                            </th>
                            <th>商家SKU码</th>
                            <th>商家条形码</th>
                            <th>国际码</th>
                            <th>销售价</th>
                            <th>库存</th>
                        </tr>

                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in tableItems" :key="`item-`+index" v-if="tableItems.length > 0">
                            <td v-for="(head,num) in thsort" :key="`td`+num"
                                v-if="head==='color'&& index%calRowSpan('color') === 0"
                                :rowspan="calRowSpan('color')">
                                <div class="product-image-wrap">
                                    <div class="color-file-upload-list single-upload-list " v-if="item.colorImg" style="width:80px;height:80px;">
                                        <template>
                                            <Card class="color-single-card-wrap">
                                                <img :src="item.colorImg" style="width:60px;height:60px;">
                                                <div class="file-upload-list-cover">
                                                    <Icon type="ios-eye-outline" @click.native="handleView(item.viewImg)"></Icon>
                                                    <Icon type="ios-trash-outline" @click.native="deleteColorImag(item)"></Icon>
                                                </div>
                                            </Card>
                                        </template>
                                    </div>
                                    <div class="fc-color-upload-btn"  :ref="`colorUploadBtn`+index"  @click="openUploadPanel('colorModal','colorUploadBtn'+index,'colorShowModal',item.color.color)"
                                         v-if="!item.colorImg && item.colorImg === ''">
                                        <Icon type="md-camera" size="20"/>
                                    </div>
                                </div>
                                <span :style="{width:'10px',height:'10px',background:item.color.color,border:'1px solid transparent',borderRadius:'5px'}">&nbsp;&nbsp;
                </span>
                                <span><Input placeholder="颜色" v-model="item[head].name"  @on-change="changeTableItemColor(item.color.color,item[head].name)"
                                             style="width: 100px;margin-left: 5px;"></Input></span>
                            </td>
                            <td v-for="(head,num) in thsort" :key="`td`+num" v-if="head!=='color'">
                                <span>{{item[head].name}}</span>
                            </td>
                            <td>
                                <Input placeholder="商家SKU码" v-model="item.suk" ></Input>
                            </td>
                            <td>
                                <Input placeholder="商家条形码" v-model="item.barCode" ></Input>
                            </td>
                            <td>
                                <Input placeholder="国际码" v-model="item.internalCode" ></Input>
                            </td>

                            <td>
                                <Input placeholder="销售价" v-model="item.price" ></Input>
                            </td>
                            <td>
                                <Input placeholder="库存" v-model="item.stock" @on-blur="calcuTotalStock"></Input>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                    <div class="store-wrap">
                        库存量：
                        <Input placeholder="库存量" v-model="paasFormData.stock" style="width: auto" />
                    </div>
                    <div class="edit-oper-toolbar">
                        <Button type="primary" @click="paasFormSubmitAttr()">保存销售属性</Button>
                    </div>

                </TabPane>
                <TabPane label="商品详情">
                    <div v-show="showAttr">
                        <div ref="ueditorWrap">
                            <vue-ueditor-wrap v-model="paasFormData.description"
                                              :config="myConfig" ref="ueditor" ></vue-ueditor-wrap>
                        </div>
                        <div class="edit-oper-toolbar product-detail-toolbar">
                            <Button type="primary" @click="paasFormSubmitDesc()">保存商品详情</Button>
                        </div>
                    </div>
                </TabPane>
            </Tabs>
        </wrapper-edit>
        <FileModal id="multiFileModal"
                   @save-file="saveMultiFileData"
                   thumbnailWidth="45"
                   thumbnailHeight="45"
                   :uploadParams="multiUploadParams"
                   @on-close="hiddenModal('multiUploadModal')"
                   multiple
                   :checkedFile="sliderFiles"
                   v-if="multiUploadModal"
                   :parentNodeId = "parentNodeId"
                   :productNo="paasFormData.productNo"
                   class="paas-file-select" ></FileModal>
        <FileModal id="fileModal"
                 @save-file="saveFileData"
                 thumbnailWidth="45"
                 thumbnailHeight="45"
                 :uploadParams="uploadParams"
                 @on-close="hiddenModal"
                 v-if="uploadModal"
                 class="paas-file-select"></FileModal>
        <FileModal id="colorShowModal"
                   @save-file="saveColorData"
                   thumbnailWidth="45"
                   thumbnailHeight="45"
                   :uploadParams="colorParams"
                   @on-close="hiddenModal('colorModal')"
                   v-if="colorModal"
                   :parentNodeId = "parentNodeId"
                   :productNo="paasFormData.productNo"
                   class="paas-file-select" ></FileModal>
    </div>

</template>

<script>
    import wrapperEdit from "@components/paas/wrapper-edit";
    import metaEdit from "@assets/js/meta-edit.js";
    import Enum from '@components/paas/enum-form' //枚举渲染
    import EnumShow from '@components/paas/enum-show' //枚举渲染
    import SelectTree from '@components/paas/selectTree';
    import VueUeditorWrap from 'vue-ueditor-wrap';
    import tabsEdit from './newTabEdit.js';
    import FileModal from '@views/sys/image/imageSelect';
    import multiUploader from '@/components/paas/file/mult-uploader.vue';
    import {deleteBusinessImage} from "@api/upload.js";
    import {returnCateIdByName} from "@api/store.js";

    export default {
        name: "tabsEdit",
        mixins:[metaEdit,tabsEdit],
        components:{VueUeditorWrap,wrapperEdit,Enum,SelectTree,EnumShow,FileModal,multiUploader},
        data(){
            return {
                uploadModal:false,  //附件上传下拉框
                multiUploadModal:false,
                colorModal:false,
                visible:false,
                uploadParams: {
                    fileBusinessType: 'storeProduct',
                    fileBusinessProp: 'posterPhoto',
                    fileBusinessId: '',
                    tempId:""
                },
                multiUploadParams:{
                    fileBusinessType: 'storeProduct',
                    fileBusinessProp: 'sliderPhoto',
                    fileBusinessId: '',
                    tempId:""
                },
                colorParams:{
                    fileBusinessType: 'storeProduct',
                    fileBusinessProp: 'productColor',
                    fileBusinessId: '',
                    tempId:""
                },
                fileList:[], //视频附件
                sliderFiles:[],  //轮播图
                imageFile:{},  //宣传图
                colorFiles:[], //颜色附件
                viewPic:'',
                paasFormData:{
                    posterImage:'',
                    sliderImage:''
                },
                curWaitIndex:-1,
                curFinishIndex:-1,
                curColor:'#ffffff',
                waitUploadFiles:[],
                parentNodeId:"",  //选中品牌
            }
        },
        methods:{
            /**
             * 更改品牌
             * */
            changeBrand(val){
                if(val){
                    returnCateIdByName({enumValue:val}).then(res => {
                        this.parentNodeId = res.data;
                    })
                }
            },
            /**
             * 进入页面
             * */
            createdCallback(data) {
                this.sliderFiles = data.entity.sliderFiles;
                this.fileList = data.entity.fileList;
                //轮播图
                this.multiUploadParams.tempId = data.paasRepeatSubmitFlag;
                this.multiUploadParams.fileBusinessId = data.entity.id;
                //商品颜色图片
                this.colorParams.tempId = data.paasRepeatSubmitFlag;
                this.colorParams.fileBusinessId = data.entity.id;
            },
            /**
             * 删除属性图片
             * */
            deleteColorImag(item){
                if(!item.deleteUrl){
                    if(this.tableItems != null && this.tableItems.length > 0){
                        for(let i = 0; i < this.tableItems.length; i++){
                            if(this.tableItems[i].color.color === item.color.color){
                                this.tableItems[i].colorImg = "";
                                this.tableItems[i].viewImg = "";
                            }
                        }
                    }
                }else{
                    this.axios.post(item.deleteUrl).then(res => {

                    })
                }
            },
            /**
             * 多选附件后的操作
             * @param files
             * */
            saveMultiFileData(files){
                //比较this.slideFiles与files的，没有就加上，有的就不管
                for(let i = 0 ; i < files.length; i++){
                    let isExist = "no";
                    for(let j = 0; j < this.sliderFiles.length; j++){
                        if(files[i].id === this.sliderFiles[j].id){
                            isExist = "yes";
                            break;
                        }
                    }
                    if(isExist === "no"){
                        this.sliderFiles.push(files[i]);
                    }
                }

            },
            saveColorData(files){
                this.colorModal = false;
                if(this.tableItems != null && this.tableItems.length > 0){
                    for(let i = 0; i < this.tableItems.length; i++){
                        if(this.tableItems[i].color.color === this.curColor){
                            this.tableItems[i].colorImg = files[0].thumbnailUrl;
                            this.tableItems[i].viewImg = files[0].originalUrl;
                        }
                    }
                }

                if(this.colorFiles != null && this.colorFiles.length > 0){
                    for(let i = 0; i < this.colorFiles.length; i++){
                        let existFlag = "no";
                        for(let key in this.colorFiles[i]){
                            if(key === this.curColor){
                                existFlag = "yes";
                                break;
                            }
                        }
                        let fileItem = {};
                        let colorFileItem = {
                            width:60,
                            height:60,
                            file:files[0],
                        };
                        fileItem[this.curColor] = colorFileItem;
                        if(existFlag === "yes"){
                            this.colorFiles[i] = fileItem;
                        }else{
                            this.colorFiles.push(fileItem);
                        }
                    }
                }else{
                    let fileItem = {};
                    let colorFileItem = {
                        width:180,
                        height:180,
                        file:files[0],
                    };
                    fileItem[this.curColor] = colorFileItem;
                    this.colorFiles.push(fileItem);
                }
            },
            /**
             * 单选选中/上传附件后的操作
             * @param files
             */
            saveFileData(files){
                this.paasFormData.posterImage = files[0].thumbnailUrl;
                this.imageFile = files[0];
                this.imageFile.deleteUrl = "";
                this.uploadModal = false;
            },
            /**
             * 隐藏附件弹出框
             */
            hiddenModal(uploadFlag){
                this[uploadFlag] = false;
            },
            /**
             * 打开附件弹出框
             * @Param uploadModal
             * @param clickBtn
             * @param id
             * */
            openUploadPanel(uploadModal,clickBtn,id,color){
                if(!this.paasFormData.productNo){
                  this.$Message.error("货号不能为空") ;
                  this.$refs.paasForm.validateField('productNo');
                  return ;
                }

                if(!this.paasFormData.brand){
                    this.$Message.error("品牌不能为空") ;
                    this.$refs.paasForm.validateField('brand');
                    return ;
                }
                this[uploadModal] = true;
                //计算当前位置的top以及left
                let top = 0;
                let left = 0;
                if(clickBtn.indexOf("colorUploadBtn") !== -1){
                    this.curColor = color;
                    top = this.$refs[clickBtn][0].getBoundingClientRect().top;
                    left = this.$refs[clickBtn][0].getBoundingClientRect().left;
                }else{
                    top = this.$refs[clickBtn].getBoundingClientRect().top;
                    left = this.$refs[clickBtn].getBoundingClientRect().left;
                }
                let scrollTop = document.documentElement.scrollTop;
                this.$nextTick(()=>{
                    if(clickBtn.indexOf("colorUploadBtn") !== -1){
                        document.getElementById(id).style.top = (top+scrollTop)+"px";
                        document.getElementById(id).style.left = (left + 60 )+"px";
                        document.getElementById(id).style.width = "calc(80%  - 100px)";
                    }else{
                        document.getElementById(id).style.top = (top+scrollTop+50)+"px";
                        document.getElementById(id).style.left = left +"px";
                        document.getElementById(id).style.width = "calc(80% - 100px)";
                    }
                });
            },
            /**
             * 预览
             * */
            handleView (showUrl) {
                this.visible = true;
                this.viewPic = showUrl;
            },
            handleSingleRemove(deleteUrl) {
                if(deleteUrl && typeof(deleteUrl) !=="undefined"){
                    this.axios.post(deleteUrl).then(res => {
                        if(res.code === 200){
                            this.paasFormData.posterImage = "";
                            this.imageFile = {
                                imageId :'',
                                fileId:'',
                                fileName:'',
                                showUrl:'',
                                thumUrl:'',
                                fileType:'',
                                deleteUrl:''
                            };
                            this.$Message.success("附件删除成功");
                        }
                    }).catch(err =>{
                        this.$Message.error('附件删除失败，请重试！');
                    });
                }else{
                    this.paasFormData.posterImage = "";
                    this.imageFile = {
                        imageId :'',
                        fileId:'',
                        fileName:'',
                        showUrl:'',
                        thumUrl:'',
                        fileType:'',
                        deleteUrl:''
                    };
                }
            },
            handleWaitRemove(item){
                let deleteUrl = item.deleteUrl;
                if(deleteUrl && typeof(deleteUrl) !=="undefined"){
                    this.axios.post(deleteUrl).then(res => {
                        if(res.code === 200){
                            if(this.waitUploadFiles != null && this.waitUploadFiles.length > 0){
                                for(let i = 0; i < this.waitUploadFiles.length; i++){
                                    if(this.waitUploadFiles[i].id === item.id){
                                        this.waitUploadFiles.splice(i,1);
                                        break;
                                    }
                                }
                            }
                            this.$Message.success("附件删除成功");
                        }
                    }).catch(err =>{
                        this.$Message.error('附件删除失败，请重试！');
                    });
                }else{
                    if(this.waitUploadFiles != null && this.waitUploadFiles.length > 0){
                        for(let i = 0; i < this.waitUploadFiles.length; i++){
                            if(this.waitUploadFiles[i].id === item.id){
                                this.waitUploadFiles.splice(i,1);
                                break;
                            }
                        }
                    }
                }
            },
            openUploadImagPanel(){},
            /**
             * 移除轮播图
             * @param fileId
             */
            spliceSliderFile(fileId){
                if(this.sliderFiles != null && this.sliderFiles.length > 0){
                    for(let i = 0; i < this.sliderFiles.length; i++){
                        if(this.sliderFiles[i].id === fileId){
                            this.sliderFiles.splice(i,1);
                            break;
                        }
                    }
                }
            },
            /**
             * 删除上传的附件
             * @param item
             */
            handleFinishRemove (item) {
                //如若是修改
                if(this.paasFormData.id){
                    let param = {
                        businessId:this.paasFormData.id,
                        fileId:item.id
                    };
                    deleteBusinessImage(param).then(res => {
                        if(res.code === 200){
                            this.spliceSliderFile(item.id);
                            this.$Message.info("删除轮播图附件成功！");
                        }
                    })
                }else{
                    this.spliceSliderFile(item.fileId);
                }
            },
        }
    }
</script>

<style scoped>

    .field-wrap{
        border-bottom:1px solid #ccc;
    }
    .field-prop-title{
        margin:10px 0;
    }
    .checkbox-flex{
        display:flex;
        flex-wrap:wrap;
        justify-content:  flex-start;
    }
    table.product-prop-table{
        border-collapse:collapse;
        border:solid 1px Black;
        margin-top:10px;
        width:100%;
    }
    table tr th,table  tr  td{
        border:1px solid #5f5f5f;
        width:12%;
        text-align:left;
        padding:0 3px;
    }
    .store-wrap{
        margin:10px;
    }
    .fc-upload-btn,.fc-color-upload-btn{
        width: 58px;
        height: 58px;
        text-align: center;
        line-height: 58px;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, .1);
        margin-right: 4px;
        box-sizing: border-box;
        border: 1px dashed #c0ccda;
        cursor: pointer;
    }
    .fc-color-upload-btn{
        margin:2px auto;
    }
    .file-upload-list{
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .color-file-upload-list{
        text-align: center;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin:2px auto;
    }
    .multi-upload-list,.single-upload-list{
        padding:15px 10px;
        display:flex;
        justify-content: flex-start;
        border:none;
        box-shadow: none;
        flex-wrap:wrap;
        width:100%;
        height:auto;
    }
    .single-upload-list{
        padding:0px;
    }
    .file-upload-list img{
        width: 120px;
        height: 120px;
    }
    .multi-upload-list  img, .single-upload-list img{
        margin-left: -8px;
        margin-top: -8px;
        flex-wrap: wrap;
    }
    .file-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
        text-align: center;
    }
    .file-upload-list:hover .file-upload-list-cover,.color-file-upload-list:hover .file-upload-list-cover{
        display: block;
    }

    .file-upload-list-cover i{
        color: #fff;
        font-size: 30px;
        cursor: pointer;
        margin: 50px 2px;
    }
    .single-upload-list .file-upload-list-cover i{
        margin:20px 2px;
    }
    .paas-file-select{
        position:absolute;
        z-index: 1;
    }
    .multi-card-wrap{
        width:140px;
        height:140px;
        margin: 0 4px;
    }
    .single-card-wrap{
        width: 200px;
        height: 200px;
        margin: 0 4px;
    }
    .product-image-wrap{
        text-align:center;
    }
    .ivu-tabs-tabpane{
        position:relative;
    }
    .product-detail-toolbar{
        width: 120px;
        position: absolute;
        top: 350px;
        right: 0;
        z-index: 10000;
    }
    .form-tabs >>> .ivu-tabs{
        overflow: unset;
    }
</style>
